import { render, staticRenderFns } from "./pointOrderSetting.vue?vue&type=template&id=39c62fb0&"
import script from "./pointOrderSetting.vue?vue&type=script&lang=js&"
export * from "./pointOrderSetting.vue?vue&type=script&lang=js&"
import style0 from "./pointOrderSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports